/// <reference types="@angular/localize" />

import { includeBearerTokenInterceptor, UserActivityService } from "keycloak-angular";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { APP_ROUTES } from "./app/app.routes";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app/app.component";
import { importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideToastr } from "ngx-toastr";
import { provideRouter, withDebugTracing, withRouterConfig } from "@angular/router";
import { providePiensoAuthorization } from "./app/shared/auth/pienso-keycloak-provider";
import { authInterceptor } from "./app/shared/auth/auth.interceptor";
import { notFoundInterceptor } from "./app/shared/notfound.interceptor";

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule, FontAwesomeModule, NgbDropdownModule),
    providePiensoAuthorization(),
    UserActivityService,
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor, authInterceptor, notFoundInterceptor])),
    provideAnimations(),
    provideToastr({
      timeOut: 10000,
      positionClass: "toast-top-center",
      closeButton: true,
    }),
    provideRouter(APP_ROUTES, withRouterConfig({ onSameUrlNavigation: "reload" }) /* withDebugTracing() */),
  ],
}).catch((err) => console.error(err));
